import { render, staticRenderFns } from "./ReviewStarsColor.vue?vue&type=template&id=832ae07e"
import script from "./ReviewStarsColor.vue?vue&type=script&lang=js"
export * from "./ReviewStarsColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports